module.exports = __webpack_public_path__ + "img/icon_download@3x.386ec02b.png";